import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { TextInput } from '../LoginPage/TextInput'
import { TwButton } from '../../components/Button/TwButton'
import { Modal } from '../../components/Modal'

interface PasskeyNameDialogProps {
  open: boolean
  title: string
  initialValue: string
  /** Called with the trimmed name, or null when cancelled */
  onClose: (name: string | null) => void
}

export const PasskeyNameDialog: React.FC<PasskeyNameDialogProps> = ({
  open,
  title,
  initialValue,
  onClose,
}) => {
  const { t } = useTranslation()
  const [name, setName] = React.useState(initialValue)

  React.useEffect(() => {
    if (open) setName(initialValue)
  }, [open, initialValue])

  const trimmed = name.trim()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!trimmed) return
    onClose(trimmed)
  }

  return (
    <Modal
      isOpen={open}
      onClose={() => onClose(null)}
      labelledBy="passkey-name-title"
      panelClassName="sm:max-w-sm"
    >
      <form onSubmit={handleSubmit} className="p-5">
        <h3 id="passkey-name-title" className="text-base font-semibold text-gray-900">
          {title}
        </h3>
        <TextInput
          label={t('profilePage.passkeys.nameDialog.label')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={120}
          autoFocus
        />
        <div className="mt-5 flex justify-end gap-2">
          <TwButton variant="outline" onClick={() => onClose(null)}>
            {t('profilePage.passkeys.nameDialog.cancel')}
          </TwButton>
          <TwButton type="submit" variant="solid" disabled={!trimmed}>
            {t('profilePage.passkeys.nameDialog.save')}
          </TwButton>
        </div>
      </form>
    </Modal>
  )
}
